import {
    AuditIcon,
    CommentIcon,
    FeedsIcon,
    RubleIcon,
    AIIcon,
    ChatBotIcon,
    NotificationIcon,
    SaleIcon,
} from '../../../../../shared/ui/Icons';
import { SettingCardProps } from '../service/setting.interface';
import { KeyIcon } from '../../../../../shared/ui/Icons/KeyIcon';

export const settings = [
    {
        key: 'legal',
        title: 'Юридические данные',
        icon: AuditIcon,
        position: 10,
        link: 'legal',
    },
    {
        key: 'support',
        title: 'Чат поддержки',
        icon: CommentIcon,
        position: 20,
        link: 'support',
    },
    {
        key: 'payment',
        title: 'Оплата',
        icon: RubleIcon,
        position: 30,
        link: 'payment-settings',
    },
    {
        key: 'feeds',
        title: 'Фиды',
        icon: FeedsIcon,
        position: 40,
        link: 'feeds',
    },
    {
        key: 'aiProfile',
        title: 'ИИ профиль',
        icon: AIIcon,
        position: 50,
        link: 'ai-assistant',
    },
    {
        key: 'bot',
        title: 'Бот',
        icon: ChatBotIcon,
        position: 60,
        link: 'bot-settings/main',
    },
    {
        key: 'integrationEmail',
        title: 'Рассылки',
        icon: NotificationIcon,
        position: 70,
        link: 'integration-email',
    },
    {
        key: 'promocodes',
        title: 'Промокоды',
        icon: SaleIcon,
        position: 80,
        link: 'promocodes',
    },
    {
        key: 'apiKeys',
        title: 'API ключи',
        icon: KeyIcon,
        position: 90,
        link: 'api-keys',
    },
] as const satisfies readonly SettingCardProps[];

export type SettingKeys = (typeof settings)[number]['key'];

export const SETTING_KEYS = Object.freeze(
    settings.reduce((acc, s) => {
        acc[s.key] = s.key;
        return acc;
    }, {} as Record<SettingKeys, SettingKeys>)
);

const visibleKeysByType: Record<number, SettingKeys[]> = {
    0: [
        SETTING_KEYS.legal,
        SETTING_KEYS.support,
        SETTING_KEYS.payment,
        SETTING_KEYS.feeds,
        SETTING_KEYS.aiProfile,
        SETTING_KEYS.bot,
        SETTING_KEYS.integrationEmail,
        SETTING_KEYS.promocodes,
    ],
    1: [SETTING_KEYS.legal, SETTING_KEYS.support, SETTING_KEYS.apiKeys],
    2: [SETTING_KEYS.legal, SETTING_KEYS.support, SETTING_KEYS.apiKeys],
};

export const getVisibleSettings = (type: number): SettingCardProps[] => {
    const keys = visibleKeysByType[type];
    if (!keys) return [];
    return settings.filter(setting => keys.includes(setting.key));
};
